import { type GraphResponseBody, renderGraphSvg } from '@ipfabric/utils';
import { loadGraphFonts } from 'components/Graph/helpers/loadGraphFonts';
import { toPngDataUrl } from 'utils/image/toPngDataUrl';

/**
 * Empirically determined to render into png for site documentation in reasonable quality,
 * actual image size in documentation is determined by output document builder.
 */
const OUTPUT_IMAGE_WIDTH = 1000;

export const convertGraphToImage = async (
  input: GraphResponseBody,
): Promise<Buffer> => {
  await loadGraphFonts();
  const graphSvg = renderGraphSvg({
    boxLabels: input.graphResult.boxLabels,
    nodes: input.graphResult.graphData.nodes,
    edges: input.graphResult.graphData.edges,
  });
  const pngDataUrl = await toPngDataUrl(
    `data:image/svg+xml;base64,${btoa(graphSvg)}`,
    { width: OUTPUT_IMAGE_WIDTH },
  );
  return Buffer.from(
    pngDataUrl.replace(/^data:image\/\w+;base64,/, ''),
    'base64',
  );
};
